/**
 * FloatingSaveButton — a save/update action that stays reachable while a
 * long form scrolls, mirroring the floating close button in ui/dialog.jsx.
 *
 * Render it as the LAST child of the tall scrolling content (just before the
 * existing footer). The zero-height sticky wrapper means it pins to the
 * bottom-right of the scrollport while scrolling, then settles above the
 * real footer once the user reaches the end — so the two never overlap.
 */
import React from 'react';
import { Save } from 'lucide-react';

export const FloatingSaveButton = ({
  onClick,
  label = 'Save',
  disabled = false,
  type = 'button',
  testId = 'floating-save-btn',
  icon: Icon = Save,
}) => (
  <div className="sticky bottom-0 z-40 !mt-16 h-0 flex justify-end items-end pointer-events-none">
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      title={label}
      aria-label={label}
      data-testid={testId}
      className="pointer-events-auto mb-1 mr-1 inline-flex h-11 w-11 items-center justify-center rounded-full bg-[#AA0000] text-white shadow-lg shadow-black/25 ring-1 ring-black/10 transition-[background-color,box-shadow,transform] duration-150 hover:bg-[#880000] hover:shadow-xl active:scale-95 focus:outline-none focus:ring-2 focus:ring-[#AA0000] focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none"
    >
      <Icon className="h-5 w-5" />
    </button>
  </div>
);

export default FloatingSaveButton;
